import { UPDATE_COMPANY_INFO_MUTATION } from "@/apis/gql/apolloClient";
import { useMutation } from "@apollo/client";

export const useUpdateCompanyInfo = () => {
  const [updateCompanyInfo] = useMutation(UPDATE_COMPANY_INFO_MUTATION);

  return { updateCompanyInfo };
};
